(function() {
  const hierarchy = {
    'Round': {
      'Plain': ['Single', 'Multi'],
      'Line/Frame': ['Single', 'Multi'],
      'Volume': ['Single', 'Multi'],
      'Variation': ['Single', 'Multi']
    },
    'Triangle': {
      'Plain': ['Single', 'Multi'],
      'Line/Frame': ['Single', 'Multi'],
      'Volume': ['Single', 'Multi'],
      'Variation': ['Single', 'Multi']
    },
    'Square': {
      'Plain': ['Single', 'Multi'],
      'Line/Frame': ['Single', 'Multi'],
      'Volume': ['Single', 'Multi'],
      'Variation': ['Single', 'Multi']
    },
    'Heart': {
      'Plain': ['Single', 'Multi'],
      'Line/Frame': ['Single', 'Multi'],
      'Volume': ['Single', 'Multi'],
      'Variation': ['Single', 'Multi']
    },
    'Animal': {
      'Mammal': ['Cat', 'Dog', 'Bear', 'Rabbit', 'Unicorn', 'Horse', 'Mole', 'Squirrel'],
      'Bugs': ['Butterfly', 'Bee', 'Ladybug', 'Snail'],
      'Marine': ['Whale', 'Fish', 'Ammoniumite', 'Shellfish'],
      'Bird': ['Birds', 'Owl']
    },
    'Food': {
      'Fruit': ['Strawberry', 'Cherry', 'Grape', 'Apple', 'Pineapple', 'Watermelon'],
      'Bakery': ['Candy', 'Bread']
    },
    'Flower': {
      'Single': ['Daisy', 'Rose', 'Etc'],
      'Leaf': ['Leaves', 'Tree']
    },
    'Universe': {
      'Weather': ['Sun', 'Cloud', 'Lightning'],
      'Twinkle': ['Star', 'Moon', 'Sun&Moon', 'Constellation', 'Planet'],
      'People': ['Face', 'Expression']
    },
    'Atypical': {
      'Wave': ['Single', 'Multi'],
      'Twist': ['Single', 'Multi'],
      'Texture': ['Cutting', 'Anamel']
    }
  };

  function findSection(container, keyword) {
    const sections = container.querySelectorAll('[data-filter-type], .facet-group, [role="group"]');
    for (let s of sections) {
      const type = s.getAttribute('data-filter-type') || '';
      if (type.includes(keyword) || s.textContent.includes(keyword)) return s;
    }
    return null;
  }

  function getCheckedValue(section) {
    if (!section) return null;
    const checked = section.querySelector('input[type="checkbox"]:checked');
    if (!checked) return null;
    const label = checked.closest('label');
    return label ? label.textContent.trim().replace(/\s*\(\d+\)\s*$/, '').trim() : null;
  }

  function filterSection(section, allowed) {
    if (!section) return;
    section.querySelectorAll('input[type="checkbox"]').forEach(cb => {
      const label = cb.closest('label');
      if (!label) return;
      const text = label.textContent.trim().replace(/\s*\(\d+\)\s*$/, '').trim();
      const show = !allowed || allowed.includes(text);
      const item = cb.closest('li') || cb.closest('.facet-item') || label.parentElement;
      if (item) item.style.display = show ? '' : 'none';
      if (!show && cb.checked) cb.checked = false;
    });
  }

  function update(container) {
    const primarySection = findSection(container, 'shape_group') || findSection(container, '대분류');
    const subSection = findSection(container, 'shape_detail') || findSection(container, '중분류');
    const subSubSection = findSection(container, 'shape_sub') || findSection(container, '소분류');

    const primary = getCheckedValue(primarySection);
    const sub = getCheckedValue(subSection);

    // 중분류 필터링
    const allowedSub = primary && hierarchy[primary] ? Object.keys(hierarchy[primary]) : null;
    filterSection(subSection, allowedSub);

    // 소분류 필터링
    const allowedSubSub = primary && sub && hierarchy[primary]?.[sub] ? hierarchy[primary][sub] : null;
    filterSection(subSubSection, allowedSubSub);
  }

  function init() {
    const container = document.querySelector('[data-facets]') || document.querySelector('.facets');
    if (!container) return;
    container.addEventListener('change', function(e) {
      if (e.target.type === 'checkbox') setTimeout(() => update(container), 50);
    }, true);
    update(container);
  }

  new MutationObserver(() => init()).observe(document.body, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', () => setTimeout(init, 100));
})();
